export enum TipoCacheRespuestaEnum {
    RANGOS_EDAD, GENEROS, PAISES, REGIONES, CIUDADES, RESPUESTA
}
